import Vue from 'vue'
import Vuex from 'vuex'
import firebase from 'firebase/app'
import router from '@/router';
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        user: null,
        userEmail: '',
        userName: '',
        authenticated: false,
        status: null,
        error: null,
        todos: null,
        users: null,
        isAdmin: null
    },

    plugins: [createPersistedState()],

    mutations: {

        setUser(state, payload) {
            state.user = payload
        },

        setUserEmail(state, payload) {
            state.userEmail = payload
        },

        setUserName(state, payload) {
            state.userName = payload
        },

        setIsAuthenticated(state, payload) {
            state.authenticated = payload
        },

        setTodos(state, payload) {
            state.todos = payload
        },

        setStatus(state, payload) {
            state.status = payload
        },

        setError(state, payload) {
            state.error = payload
        },

        setUsers(state, payload) {
            state.users = payload
        },

        setAdmin(state, payload) {
            state.users = payload
        }

    },
    actions: {
        // sign-in
        signInAction({ commit }, payload) {
            // console.log(payload)
            return new Promise((resolve, reject) => {
                firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(function() {
                    firebase
                        .auth()
                        .signInWithEmailAndPassword(payload.email, payload.password)
                        .then((response) => {
                            commit('setUser', response.user.uid)
                            commit('setUserEmail', response.user.email)
                            commit('setIsAuthenticated', true)
                            commit('setStatus', 'success')
                            commit('setError', null)
                            localStorage.user = true;
                            router.push('/todos')
                            resolve(response)
                        })
                        .catch((error) => {
                            commit('setStatus', 'failure')
                            commit('setIsAuthenticated', false)
                            commit('setError', error.message)
                                // router.push('/')
                            reject(error.message)
                        })
                })
            })

        },

        // sign-out
        signOutAction({ commit }) {
            firebase.auth().signOut()
                .then(() => {
                    commit('setUser', null)
                    commit('setUserEmail', null)
                    commit('setUserName', null)
                    commit('setUsers', null)
                    commit('setStatus', 'success')
                    commit('setError', null)
                    commit('setTodos', null)
                    commit('setIsAuthenticated', false)
                    router.push({ name: 'Home' })
                })
                .catch((error) => {
                    commit('setStatus', 'failure')
                    commit('setError', error.message)
                    commit('setUser', null);
                    commit('setIsAuthenticated', false);
                    // router.push('/');
                })
        },

        // load todos
        loadTodos({ commit }) {
            // get all of the customer entries
            return new Promise((resolve, reject) => {
                return firebase
                    .database()
                    .ref('todos')
                    .once('value', snapshot => {
                        commit('setTodos', snapshot.val())
                    })
                    .then(() => {
                        // check if current User ID is in List of users
                        // and set username accordingly
                        let allUsers = this.getters.getUsers
                        const values = Object.values(allUsers)
                        for (let obj of values) {
                            const entries = Object.entries(obj)
                            for (const [key, value] of entries) {
                                if (key == "ID" && value == this.getters.getUser) {
                                    commit("setUserName", obj["Name"])
                                }
                            }
                        }
                        commit('setStatus', 'success')
                        return (resolve)
                    })
                    .catch((error) => {
                        commit('setStatus', 'failure')
                        commit('setError', error)
                        return (reject)
                    })
            })
        },
        // load users
        loadUsers({ commit }) {
            return new Promise((resolve, reject) => {
                return firebase
                    .database()
                    .ref('users/')
                    .once('value', snapshot => {
                        commit('setUsers', snapshot.val())
                    })
                    .then(() => {
                        commit('setStatus', 'success')
                        if (this.getUsers[this.getUser.uid]) {
                            commit('setAdmin', true)
                        }
                        return (resolve)
                    })
                    .catch((error) => {
                        commit('setStatus', 'failure')
                        commit('setError', error)
                        return (reject)
                    })
            });
        },
        // add todo
        addTodo({ commit }, payload) {
            return new Promise((resolve, reject) => {
                return firebase
                    .database()
                    .ref('todos/')
                    .push(payload)
                    .then(() => {
                        commit('setStatus', 'success')
                        this.dispatch('loadTodos')
                        return (resolve)
                    })
                    .catch((error) => {
                        commit('setStatus', 'failure')
                        commit('setError', error)
                        return (reject)
                    })
            })
        },
        // add note
        addNote({ commit }, payload) {
            let noteObject = {
                "Date": payload[1],
                "Time": payload[2],
                "Note": payload[3],
                "Person": payload[4]
            }
            return new Promise((resolve, reject) => {
                return firebase
                    .database()
                    .ref('todos/' + payload[0] + '/Notes')
                    .push(noteObject)
                    .then(() => {
                        commit('setStatus', 'success')
                        this.dispatch('loadTodos')
                        return (resolve)
                    })
                    .catch((error) => {
                        commit('setStatus', 'failure')
                        commit('setError', error)
                        return (reject)
                    })
            })
        },
        // remove todo

    },
    getters: {
        // get user
        getUser(state) {
            return state.user
        },
        // get userEmail
        getUserEmail(state) {
            return state.userEmail
        },
        // get userName
        getUserName(state) {
            return state.userName
        },
        // get status
        getStatus(state) {
            return state.status
        },
        // get error
        getError(state) {
            return state.error
        },
        // get todoEntries
        getTodos(state) {
            return state.todos
        },
        // get Users
        getUsers(state) {
            return state.users
        }
    },
    modules: {}
})